import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $profileFeatureStore } from '@lib/store/profile';
import { useAccountFlow, useCurrencySymbol } from '@shared/hooks';
import { FormatUtils, RoutePaths } from '@shared/utils';
import { AccountType, type AccountResponse } from '@shared/api/rest/accounts';
import { Button, ColorsEnum, Icon, Text } from '@shared/widgets';
import TrashIcon from '@assets/icons/trash.svg';
import { useState } from 'react';
import { ModalDeleteConfirmation } from '../modals';

export interface ISmallAccountProps {
  account: AccountResponse;
  removeAccount: (id: number) => void;
}

export const SmallAccount = (props: ISmallAccountProps) => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);

  const [isViewModal, setIsViewModal] = useState<boolean>(false);

  const symbol = useCurrencySymbol(props.account.currency);
  const accountFlow = useAccountFlow(profileFeatureStore.data?.accountFlows, props.account.id);

  if (!accountFlow?.view) return null;
  return (
    <>
      <div className='mb-6 flex items-center border-b border-b-gray-black pb-6 last:mb-0 last:border-none last:pb-0'>
        <Link className='flex-auto pr-3' to={RoutePaths.account.onNavigate(props.account.id)}>
          <Text className='overflow-hidden text-ellipsis' weight='medium' size='xs' color={ColorsEnum.Secondary} uppercase>
            {props.account.productName}
          </Text>
          <Text className='overflow-hidden text-ellipsis' weight='medium' size='xs' color={ColorsEnum.Secondary} uppercase>
            {props.account.type === AccountType.Payment ? props.account.iban : FormatUtils.toSliceNumber(props.account.accountNumber)}
          </Text>
          <Text weight='medium' className='overflow-hidden text-ellipsis'>
            {symbol} {AccountType.Payment ? props.account.availableBalance : props.account.balance}
          </Text>
        </Link>
        <Button color='icon' onClick={() => setIsViewModal(true)}>
          <Icon icon={<TrashIcon />} />
        </Button>
      </div>
      {isViewModal && (
        <ModalDeleteConfirmation
          onClose={() => setIsViewModal(false)}
          id={props.account.id}
          type={AccountType.Payment}
          onDelete={props.removeAccount}
        />
      )}
    </>
  );
};
